module.exports = __webpack_public_path__ + "img/vino-degust-empty.1fd6cea3.png";